import { MenuItemMetadata, MenuMetadataForChannel, MetadataTag, TagType } from '@/models';

export function findMetadataForMenuItem(
  itemId: string,
  metadata: MenuMetadataForChannel,
): MenuItemMetadata | undefined {
  return metadata.items[itemId];
}

export function getVariantsItemSectionTitle(metadata: MenuMetadataForChannel | null, modeEntreeType: string | null = null): string {
  const section = metadata && metadata.itemSections[getVariantsItemSectionName(modeEntreeType)];
  return section ? section.alias : '';
}

export function getVariantsItemSectionName(modeEntreeType: string | null = null) : string {  
  // Currently, all previous protein level sections (i.e. Fillings) share the same section title, using a dummy section that comes from MMD to get 
  // this alias. There is no explicit mapping anywhere (e.g. Burrito using the Fillings section). To show a different section title for BYO Protein
  // and Chips, we need to differentiate on the builder mode's entree type to determine which section name to use to retrieve the correct alias from MMD
  switch(modeEntreeType) {
    case 'BYOProtein': 
      return 'BYOProteinFilling';
    case 'BYOChips': 
      return 'BYOChipsFilling';
    default:
      return 'Filling';
  }
}


export function isMenuItemRewardsExclusive(tags: MetadataTag[]): boolean {
  return tags?.find(tag => tag.type == TagType.Rewards)?.type ? true : false;
}

export function getRewardsExclusiveTagText(tags: MetadataTag[]): string {
  return tags?.find(tag => tag.type == TagType.Rewards)?.value || '';
}